import pathRoutes from "../../../routes/pathRoutes";
import { Edit, Remove } from "@app/components/Actions";
import { useMasterTables } from "./useMasterTables";
import { PermissionComponentGate } from "@app/utils/PermissionComponentGate";
import { RolesTypes } from "@app/pages/users/utils/helpers";

export const columnsMasterTables = (
  keysTables: string[],
  tableName: string
) => {
  if (!keysTables || keysTables.length === 0) return [];

  const dynamicColumns = keysTables.map((key) => ({
    field: key,
    headerName: `${key}`,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params: any) => <div>{params.row[key]}</div>,
  }));

  const actionsColumn = {
    field: "actions",
    headerName: "Acciones",
    headerAlign: "center",
    align: "left",
    flex: 1,
    renderCell: (params: any) => (
      <>
        <PermissionComponentGate
          permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}
        >
          <Edit
            to={`${pathRoutes.ADMIN_MASTER_TABLES}/editar/${tableName}/${params.id}`}
          />
          <Remove
            onRemove={() =>
              useMasterTables.getState().deleteData(params.id, tableName)
            }
            title="Va a borrar de forma permanente este registro"
            text="¿Quiere continuar?"
          />
        </PermissionComponentGate>
      </>
    ),
  };

  return [...dynamicColumns, actionsColumn];
};
